<!-- Breadcrumb Area -->
<!-- End Breadcrumb Area -->

<!-- <div class="row">
    <div class="col-lg-3 col-md-6">
        <div class="stats-card-box">
            <div class="icon-box">
                <i class='bx bx-bar-chart'></i>
            </div>
            <span class="sub-title">Conversion Rate</span>
            <h3>5.45% <span class="badge"><i class='bx bx-up-arrow-alt'></i> 56.9%</span></h3>

            <div class="progress-list">
                <div class="bar-inner">
                    <div class="bar progress-line" data-width="56.9"></div>
                </div>

                <p>Ratio website’s visitors</p>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stats-card-box">
            <div class="icon-box">
               <i class='bx bx-bar-chart-square'></i>
            </div>
            <span class="sub-title">Conversion Value</span>
            <h3>4.75% <span class="badge"><i class='bx bx-up-arrow-alt'></i> 32.1%</span></h3>

            <div class="progress-list">
                <div class="bar-inner">
                    <div class="bar progress-line" data-width="32.1"></div>
                </div>

                <p>Ratio website’s visitors</p>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stats-card-box">
            <div class="icon-box">
                <i class='bx bx-bar-chart-alt'></i>
            </div>
            <span class="sub-title">Conversion Order</span>
            <h3>6.47% <span class="badge badge-red"><i class='bx bx-down-arrow-alt'></i> 45.5%</span></h3>

            <div class="progress-list">
                <div class="bar-inner">
                    <div class="bar progress-line" data-width="45.5"></div>
                </div>

                <p>Ratio website’s visitors</p>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stats-card-box">
            <div class="icon-box">
                <i class='bx bx-send'></i>
            </div>
            <span class="sub-title">Subscribers Gained</span>
            <h3>92.6% <span class="badge"><i class='bx bx-up-arrow-alt'></i> 26.0%</span></h3>
            <div class="progress-list">
                <div class="bar-inner">
                    <div class="bar progress-line" data-width="26.0"></div>
                </div>
                <p>Subscribe in month</p>
            </div>
        </div>
    </div>
</div> -->

<!-- Start -->
<!-- <div class="row" id="result-general">
    <div class="col-lg-6 col-md-12">
        Website Website Analytics
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRAFICA DE RESULTADOS</h3>
                <span [ngClass]="favorites[0]?'clicked':'clickeable'" (click)="addFavorite(0)"><i
                        [ngClass]="favorites[0]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-accounting-chart-result></app-accounting-chart-result>
        </div>
        End Website Analytics
    </div>

    <div class="col-lg-6 col-md-12" id="general-chart">
        Email Send Chart
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRÁFICO DE BALANCE GENERAL <span class="text-muted" data-bs-toggle="tooltip"
                        data-bs-title="Haz click sobre una columna para ver el detalle de la misma"><i
                            class="fa fa-circle-info"></i></span></h3>

                <span [ngClass]="favorites[1]?'clicked':'clickeable'" (click)="addFavorite(1)"><i
                        [ngClass]="favorites[1]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>

            <app-accounting-chart-balance></app-accounting-chart-balance>
        </div>
        End Email Send Chart
    </div>
</div> -->
<!-- 
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRÁFICO DE GASTOS</h3>
                <span [ngClass]="favorites[2]?'clicked':'clickeable'" (click)="addFavorite(2)"><i
                        [ngClass]="favorites[2]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-accounting-chart-expenses></app-accounting-chart-expenses>
        </div>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRÁFICO DE GANANCIAS VS COSTOS Y GASTOS</h3>
                <span [ngClass]="favorites[3]?'clicked':'clickeable'" (click)="addFavorite(3)"><i
                        [ngClass]="favorites[3]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-accounting-chart-profits-vs-costs></app-accounting-chart-profits-vs-costs>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>VENTA VS FACTURACIÓN (GENERAL)</h3>
                <span [ngClass]="favorites[4]?'clicked':'clickeable'" (click)="addFavorite(4)"><i
                        [ngClass]="favorites[4]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-sale-detail-chart></app-sale-detail-chart>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>VENTA POR ESTABLECIMIENTO (ESTACIONALIDAD)</h3>
                <span [ngClass]="favorites[5]?'clicked':'clickeable'" (click)="addFavorite(5)"><i
                        [ngClass]="favorites[5]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-sale-establishment></app-sale-establishment>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>FACTURACIÓN POR ESTABLECIMIENTO (ESTACIONALIDAD) </h3>
                <span [ngClass]="favorites[6]?'clicked':'clickeable'" (click)="addFavorite(6)"><i
                        [ngClass]="favorites[6]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-sale-invoice-detail-chart></app-sale-invoice-detail-chart>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GASTO POR ESTABLECIMIENTO (ESTACIONALIDAD)</h3>
                <span [ngClass]="favorites[7]?'clicked':'clickeable'" (click)="addFavorite(7)"><i
                        [ngClass]="favorites[7]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-expenses-general-establishment-report></app-expenses-general-establishment-report>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GASTO POR ESTABLECIMIENTO (RUBROS)</h3>
                <span [ngClass]="favorites[8]?'clicked':'clickeable'" (click)="addFavorite(8)"><i
                        [ngClass]="favorites[8]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-expenses-type-establishment-report></app-expenses-type-establishment-report>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>CUENTAS COBRAR VS CUENTAS PAGAR,PROVEEDORES(GENERAL) </h3>
                <span [ngClass]="favorites[9]?'clicked':'clickeable'" (click)="addFavorite(9)"><i
                        [ngClass]="favorites[9]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-billpay-receivable-provider></app-billpay-receivable-provider>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>INVENTARIO VS PROVEEDORES</h3>
                <span [ngClass]="favorites[10]?'clicked':'clickeable'" (click)="addFavorite(10)"><i
                        [ngClass]="favorites[10]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-provider-inventory-establishment-report [warehouses]="warehouses"></app-provider-inventory-establishment-report>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>INVENTARIO POR CRONOLOGIA</h3>
                <span [ngClass]="favorites[11]?'clicked':'clickeable'" (click)="addFavorite(11)"><i
                        [ngClass]="favorites[11]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-inventory-chronology-report [warehouses]="warehouses"></app-inventory-chronology-report>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>PROVEEDORES POR CRONOLOGIA</h3>
                <span [ngClass]="favorites[12]?'clicked':'clickeable'" (click)="addFavorite(12)"><i
                        [ngClass]="favorites[12]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-provider-chronology-report [warehouses]="warehouses"></app-provider-chronology-report>
        </div>>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>CUENTA POR PAGAR POR CRONOLOGIA</h3>
                <span [ngClass]="favorites[13]?'clicked':'clickeable'" (click)="addFavorite(13)"><i
                        [ngClass]="favorites[13]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-bill-receivable-chronology></app-bill-receivable-chronology>
        </div>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>CUENTAS POR PAGAR POR CRONOLOGIA</h3>
                <span [ngClass]="favorites[14]?'clicked':'clickeable'" (click)="addFavorite(14)"><i
                        [ngClass]="favorites[14]?'fa-solid fa-star':'fa-regular fa-star'"></i></span>
            </div>
            <app-billpay-chronology></app-billpay-chronology>
        </div>
    </div>
</div> -->
<!-- <div class="row">
    <div class="col-lg-5 col-md-12">
        <div class="card mb-30 pt-2">
            <div class="card-body activity-timeline-chart-box">
                <app-activity-timeline></app-activity-timeline>

                <div class="activity-timeline-content">
                    <div class="card-header">
                        <h3>Activity Timeline</h3>
                    </div>

                    <ul>
                        <li>
                            <i class='bx bx-check-double'></i>
                            <span>Organic Search</span>
                            2,862 0.7%
                        </li>

                        <li>
                            <i class='bx bx-check-double'></i>
                            <span>Referral Visitor</span>
                            1,142 0.5%
                        </li>

                        <li>
                            <i class='bx bx-check-double'></i>
                            <span>Email Campaign</span>
                            3,214 0.5%
                        </li>

                        <li>
                            <i class='bx bx-check-double'></i>
                            <span>Social Media</span>
                            2,214 0.9%
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>Activity</h3>
            </div>

            <div class="card-body activity-card-box">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="progress-list">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>Income Amount</span>
                                
                                <span>$8,098</span>
                            </div>
                            <div class="bar-inner">
                                <div class="bar progress-line" data-width="80"></div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="progress-list">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>Total Budget</span>
                                
                                <span>$7,754</span>
                            </div>
                            <div class="bar-inner">
                                <div class="bar progress-line" data-width="98"></div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="progress-list">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>Total Sales</span>
                                
                                <span>$6,542</span>
                            </div>
                            <div class="bar-inner">
                                <div class="bar progress-line" data-width="95"></div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="progress-list">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>Completed Tasks</span>
                                
                                <span>105</span>
                            </div>
                            <div class="bar-inner">
                                <div class="bar progress-line" data-width="90"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-7 col-md-12">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>Traffic Source</h3>
            </div>

            <app-traffic-source></app-traffic-source>
        </div>
        <div class="row">
            <div class="col-lg-5">
                <div class="card mb-30">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h3>Best Sales</h3>
                    </div>

                    <div class="card-body best-sales-box">
                        <ul>
                            <li class="d-flex align-items-center">
                                <span>S</span>

                                <div class="bar-inner">
                                    <div class="bar progress-line" data-width="95"></div>
                                </div>
                            </li>

                            <li class="d-flex align-items-center">
                                <span>M</span>

                                <div class="bar-inner">
                                    <div class="bar progress-line" data-width="87"></div>
                                </div>
                            </li>

                            <li class="d-flex align-items-center">
                                <span>T</span>

                                <div class="bar-inner">
                                    <div class="bar progress-line" data-width="90"></div>
                                </div>
                            </li>

                            <li class="d-flex align-items-center">
                                <span>W</span>

                                <div class="bar-inner">
                                    <div class="bar progress-line" data-width="45"></div>
                                </div>
                            </li>

                            <li class="d-flex align-items-center">
                                <span>T</span>

                                <div class="bar-inner">
                                    <div class="bar progress-line" data-width="79"></div>
                                </div>
                            </li>

                            <li class="d-flex align-items-center">
                                <span>F</span>

                                <div class="bar-inner">
                                    <div class="bar progress-line" data-width="58"></div>
                                </div>
                            </li>

                            <li class="d-flex align-items-center">
                                <span>S</span>

                                <div class="bar-inner">
                                    <div class="bar progress-line" data-width="77"></div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-7">
                <div class="card mb-30">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h3>Browser Used</h3>
                    </div>

                    <div class="card-body browser-used-box">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Browser</th>
                                        <th>Sessions</th>
                                        <th>Bounce Rate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Google Chrome</td>
                                        <td>13,410</td>
                                        <td>31.24% (<i class='bx bx-up-arrow-alt'></i> 39%)</td>
                                    </tr>
                                    <tr>
                                        <td>Mozila Firefox</td>
                                        <td>13,443</td>
                                        <td>30.23% (<i class='bx bx-up-arrow-alt'></i> 54%)</td>
                                    </tr>
                                    <tr>
                                        <td>Opera Mini</td>
                                        <td>1,410</td>
                                        <td>68.24% (<i class='bx bx-down-arrow-alt red'></i> 20%)</td>
                                    </tr>
                                    <tr>
                                        <td>Microsoft edge</td>
                                        <td>2,241</td>
                                        <td>67.88% (<i class='bx bx-down-arrow-alt red'></i> 45%)</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-6 col-md-12">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>Tasks</h3>
            </div>

            <div class="card-body widget-todo-list">
                <ul>
                    <li>
                        <div class="checkbox">
                            <input class="inp-cbx" id="cbx" type="checkbox" style="display: none;"/>
                            <label class="cbx" for="cbx">
                                <span>
                                    <svg width="12px" height="10px" viewbox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                    </svg>
                                </span>
                            </label>
                        </div>

                        <div class="todo-item-title">
                            <img src="assets/img/user1.jpg" data-toggle="tooltip" data-placement="top" title="Sarah Taylor" alt="image">
                            <h3>Print bills</h3>
                            <p>There are many variations of...</p>
                        </div>

                        <div class="todo-item-action">
                            <a href="javascript:void(0)" class="edit"><i class='bx bx-edit-alt'></i></a>
                            <a href="javascript:void(0)" class="delete"><i class='bx bx-trash'></i></a>
                        </div>
                    </li>

                    <li>
                        <div class="checkbox">
                            <input class="inp-cbx" id="cbx2" type="checkbox" style="display: none;"/>
                            <label class="cbx" for="cbx2">
                                <span>
                                    <svg width="12px" height="10px" viewbox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                    </svg>
                                </span>
                            </label>
                        </div>

                        <div class="todo-item-title">
                            <img src="assets/img/user2.jpg" data-toggle="tooltip" data-placement="top" title="Lucy Eva" alt="image">
                            <h3>Call Rampbo</h3>
                            <p>There are many variations of...</p>
                        </div>

                        <div class="todo-item-action">
                            <a href="javascript:void(0)" class="edit"><i class='bx bx-edit-alt'></i></a>
                            <a href="javascript:void(0)" class="delete"><i class='bx bx-trash'></i></a>
                        </div>
                    </li>

                    <li>
                        <div class="checkbox">
                            <input class="inp-cbx" id="cbx3" type="checkbox" style="display: none;"/>
                            <label class="cbx" for="cbx3">
                                <span>
                                    <svg width="12px" height="10px" viewbox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                    </svg>
                                </span>
                            </label>
                        </div>

                        <div class="todo-item-title">
                            <img src="assets/img/user3.jpg" data-toggle="tooltip" data-placement="top" title="John Smith" alt="image">
                            <h3>Print Statements all</h3>
                            <p>There are many variations of...</p>
                        </div>

                        <div class="todo-item-action">
                            <a href="javascript:void(0)" class="edit"><i class='bx bx-edit-alt'></i></a>
                            <a href="javascript:void(0)" class="delete"><i class='bx bx-trash'></i></a>
                        </div>
                    </li>

                    <li>
                        <div class="checkbox">
                            <input class="inp-cbx" id="cbx4" type="checkbox" style="display: none;"/>
                            <label class="cbx" for="cbx4">
                                <span>
                                    <svg width="12px" height="10px" viewbox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                    </svg>
                                </span>
                            </label>
                        </div>

                        <div class="todo-item-title">
                            <img src="assets/img/user4.jpg" data-toggle="tooltip" data-placement="top" title="Steven Smith" alt="image">
                            <h3>What reason think</h3>
                            <p>There are many variations of...</p>
                        </div>

                        <div class="todo-item-action">
                            <a href="javascript:void(0)" class="edit"><i class='bx bx-edit-alt'></i></a>
                            <a href="javascript:void(0)" class="delete"><i class='bx bx-trash'></i></a>
                        </div>
                    </li>

                    <li>
                        <div class="checkbox">
                            <input class="inp-cbx" id="cbx5" type="checkbox" style="display: none;"/>
                            <label class="cbx" for="cbx5">
                                <span>
                                    <svg width="12px" height="10px" viewbox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                    </svg>
                                </span>
                            </label>
                        </div>

                        <div class="todo-item-title">
                            <img src="assets/img/user5.jpg" data-toggle="tooltip" data-placement="top" title="Lucy Smith" alt="image">
                            <h3>Think about business content?</h3>
                            <p>There are many variations of...</p>
                        </div>

                        <div class="todo-item-action">
                            <a href="javascript:void(0)" class="edit"><i class='bx bx-edit-alt'></i></a>
                            <a href="javascript:void(0)" class="delete"><i class='bx bx-trash'></i></a>
                        </div>
                    </li>

                    <li>
                        <div class="checkbox">
                            <input class="inp-cbx" id="cbx6" type="checkbox" style="display: none;"/>
                            <label class="cbx" for="cbx6">
                                <span>
                                    <svg width="12px" height="10px" viewbox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                    </svg>
                                </span>
                            </label>
                        </div>

                        <div class="todo-item-title">
                            <img src="assets/img/user6.jpg" data-toggle="tooltip" data-placement="top" title="James Anderson" alt="image">
                            <h3>Reason would it be advisable</h3>
                            <p>There are many variations of...</p>
                        </div>

                        <div class="todo-item-action">
                            <a href="javascript:void(0)" class="edit"><i class='bx bx-edit-alt'></i></a>
                            <a href="javascript:void(0)" class="delete"><i class='bx bx-trash'></i></a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="col-lg-6 col-md-12">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>Where are your users?</h3>
            </div>

            <div class="card-body">
                <div id="world-map-markers"></div>
            </div>
        </div>
    </div>
</div> -->
<div class="breadcrumb-area">
    <h1>Reporte Facturas de Proveedor</h1>
</div>

<div *ngIf="dashboardUrl" style="overflow: hidden; height: 580px; margin-bottom: 10px;">
    <iframe
        [src]="dashboardUrl"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>

<div *ngIf="dashboardProducts" style="overflow: hidden; height: 580px; margin-bottom: 10px;">
    <iframe
        [src]="dashboardProducts"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>

<div *ngIf="dashboardWarehouse" style="overflow: hidden; height: 580px;">
    <iframe
        [src]="dashboardWarehouse"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>

